import React from 'react'
import BlueHeading from '../other/common/BlueHeading'
import Heading from '../common/ui/Heading'
const PrivacyHero = () => {
  return (
    <>
      <div className="bg-cover bg-center bg-no-repeat bg-privacy-hero px-4">
        <div className="max-w-[1140px] mx-auto py-[142px]  max-lg:py-32 max-md:py-24 max-sm:py-14">
          <div className="max-w-[420px] mx-auto flex items-center justify-center flex-col">
            <BlueHeading
              text="Privacy Policy"
              textClass="text-white"
              lineClassOne="!bg-white"
              lineClassTwo="!bg-white"
            />
            <Heading children="Privacy Policy" className='mt-4 text-white'/>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyHero